import { useIntl } from 'react-intl'

import Icon from 'shared/ui/Icon'
import { ColorCMYK } from 'shared/types/global'

import { Color, Container, Image, Title } from './Style'

type ItemProps = {
  titleId: string
  imageUrl: string | null
  color: ColorCMYK | null
  onImageClick: () => void
  onColorClick: () => void
}

const CoverBackgroundItem: React.FC<ItemProps> = ({
  titleId,
  imageUrl,
  color,
  onImageClick,
  onColorClick,
}) => {
  const { formatMessage } = useIntl()

  return (
    <Container>
      <Title>{formatMessage({ id: titleId })}</Title>
      <Image backgroundUrl={imageUrl}>
        <Image.Refresh onClick={onImageClick}>
          <Icon name="refresh" size={24} />
        </Image.Refresh>
      </Image>
      <Color onClick={onColorClick}>
        <Color.Circle color={color} />
        <Color.Title>Color</Color.Title>
      </Color>
    </Container>
  )
}

export default CoverBackgroundItem
